import React from "react";
import ObsIframe from "../../../iframe-component/onboarding/ObsIframe";

const AddOfflineMerchant = () => {
  return <ObsIframe path="/application" />;
};

export default React.memo(AddOfflineMerchant);
